export default "/img/CL.f9712b4a5676593b9836916b32452b59.png";